import {
  Box,
  List,
  ListItem,
  Popover,
  Switch,
  SxProps,
  Theme,
  Tooltip,
  Typography,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisVertical,
  faImage,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { useContext, useEffect, useState } from "react";
import { MainContext } from "../../../main/context/MainContextProvider";
import { toPng } from "html-to-image";
import { DashboardContext } from "../context/DashboardContexProvider";
import AvailabilityIndicators from "../../../main/components/AvailabilityIndicators";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import EditColorModal, { EditColorItemType } from "./modal/EditColorModal";
import {
  formatDataHoraCaptura,
  formatDate,
  formatDateRequest,
} from "../../../main/utils/utils";
import {
  BaseErrorCard,
  BaseUsinaStringValue,
} from "../models/dados-indicadores.model";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TuneIcon from "@mui/icons-material/Tune";
import FilterCardModal, {
  CardFilterOptionsEnum,
} from "./modal/FilterCardModal";
import { UsinaByClient } from "../../usinas/types";
import { CardTypesEnum, GetRopCardParams } from "../types";
import { SelectInputOptions } from "../../../main/components/SelectInputComponent";
import InfoIcon from "@mui/icons-material/Info";


export default function DashboardCardHeader(props: {
  icon?: React.ReactNode;
  cardError?: BaseErrorCard;
  cardId?: string;
  title?: string;
  titleFontSize?: number;
  elementRef?: React.MutableRefObject<null>;
  lastUpdate?: Date;
  hasDelay?: boolean;
  dataHoraCaptura?: string;
  hasColetaDelay?: boolean;
  isMouseIn: boolean;
  fullWidth?: boolean;
  toggleItems?: {
    disabledLabel: string;
    enabledLabel: string;
    toggleValue: boolean;
    setToggleValue: React.Dispatch<React.SetStateAction<boolean>>;
  };
  colorButton?: boolean;
  colorsOptions?: EditColorItemType[];
  openColorsModal?: boolean;
  onConfirmColorsModal?: () => void;
  setOpenColorsModal?: (openModal: boolean) => void;
  hideExportImage?: boolean;
  cardType?: number;
  hourlyValues?: BaseUsinaStringValue[];
  setHourlyValue?: React.Dispatch<React.SetStateAction<string | undefined>>;
  hasFilter?: boolean;
  equipment?: string | undefined;
  setEquipment?: (equipment: string) => void;
  possibleEquipmentTypeFilters?: SelectInputOptions[];
  possibleEquipmentFilters?: SelectInputOptions[];
  hasEquipmentFilter?: boolean;
}) {
  const {
    icon,
    cardError,
    cardId,
    title,
    titleFontSize,
    elementRef,
    isMouseIn,
    lastUpdate,
    hasDelay,
    colorsOptions,
    openColorsModal,
    setOpenColorsModal,
    onConfirmColorsModal,
    dataHoraCaptura,
    hasColetaDelay,
    fullWidth,
    hideExportImage,
    cardType,
    hourlyValues,
    setHourlyValue,
    hasFilter,
    hasEquipmentFilter,
  } = props;

  const { theme, toastNotifications, setToastNotifications, selectedDashboardUsina: selectedUsina } =
    useContext(MainContext);

  const {
    canEditLayout,
    layoutsConfig,
    setLayoutsConfig,
    cardsConfig,
    setCardsConfig,
    requestParamCards,
    setRequestParamCards,
    dashboardHistoryCards,
    equipmentFilter,
  } = useContext(DashboardContext);

  const htmlToImageConvert = () => {
    if (!elementRef?.current) return;
    toPng(elementRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "my-image-name.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((_) => {
        throw new Error("Erro ao exportar imagem");
      });
  };
  const [openFilterModal, setOpenFilterModal] = useState(false);

  const [dateFilter, setDateFilter] = useState<CardFilterOptionsEnum>(
    CardFilterOptionsEnum.Live
  );
  const [hour, setHour] = useState<number>();
  const [date, setDate] = useState<Date | null>(new Date());

  const isDisponibilidadeCard = cardId?.includes("Disponibilidade-");

  const onConfirmFilterModal = () => {
    sendDashboardHistoryParams(
      date,
      dateFilter,
      cardType ?? 0,
      selectedUsina,
      requestParamCards,
      setRequestParamCards
    );
    setOpenFilterModal(false);
  };

  useEffect(() => {
    const parsedParams = requestParamCards.map((param) => JSON.parse(param));
    const foundCard = parsedParams.find(
      (card) => card.ropCardType === cardType
    );
    if (foundCard) {
      const foundCardDate = new Date(
        new Date(foundCard.date).getTime() +
        new Date(foundCard.date).getTimezoneOffset() * 60000
      );
      setDate(foundCardDate);
    }
  }, [requestParamCards]);

  useEffect(() => {
    if (dateFilter === CardFilterOptionsEnum.Hora && setHourlyValue) {
      setHourlyValue(getHourlyValue());
    } else {
      setHourlyValue && setHourlyValue(undefined);
    }
  }, [hourlyValues]);

  const hourlyValuesValidation =
    dateFilter === CardFilterOptionsEnum.Hora && !!hour;

  const getHourlyValue = () => {
    if (isDisponibilidadeCard) {
      if (hourlyValuesValidation) {
        const valorEncontrado = hourlyValues?.find(
          (item: BaseUsinaStringValue) => {
            if (!item.dateTime) return false;
            const itemHour = new Date(item.dateTime).getHours();
            return itemHour === hour;
          }
        );
        return valorEncontrado?.value;
      }
    }
  };

  function removeCard(cardId: string) {
    const newCardsConfig = cardsConfig.filter((cardConfig) => {
      return cardConfig.id !== cardId;
    });
    setCardsConfig(newCardsConfig);
    removeCardLayout(cardId);
  }
  function removeCardLayout(cardId: string) {
    const newLayoutsConfig = { ...layoutsConfig };
    Object.keys(newLayoutsConfig.layouts).forEach((breakpoint) => {
      const breakPointKey = breakpoint as keyof typeof newLayoutsConfig.layouts;
      newLayoutsConfig.layouts[breakPointKey] = newLayoutsConfig.layouts[
        breakPointKey
      ]?.filter((layout) => {
        return layout.cardId !== cardId;
      });
    });
    setLayoutsConfig(newLayoutsConfig);
  }
  const showOptions = isMouseIn && ((canEditLayout && cardId) || elementRef);

  const handleTostError = () => {
    if (
      cardError?.Message &&
      cardError.Message !== "nenhum erro"
      // cardError &&
      // cardError.Message !== undefined &&
      // cardError.Message !== "nenhum erro"
    ) {
      const newNotifications = {
        isAdding: true,
        notifications: [
          ...toastNotifications.notifications,
          {
            severity: "error" as const,
            //precisa de ajustar na API para mostrar corretamente a lista do que falta
            text: `${cardError.Message} em desenvolvimento`,
          },
        ],
      };
      setToastNotifications(newNotifications);
    }
    return null;
  };
  const isStaticData = dashboardHistoryCards.find(
    (card) => card.card.type === cardType
  );

  function GetTooltipInfoTitle() {
    return (
      <>
        Filtro por equipamento:
        <br /> {equipmentFilter.ugName && `UG: ${equipmentFilter.ugName}`}{" "}
        <br />
        {equipmentFilter.inversorName &&
          `Inversor: ${equipmentFilter.inversorName}`}
      </>
    );
  }

  return (
    <Box
      style={{ minHeight: "32px", marginBottom: "8px" }}
      className="d-flex justify-content-between w-100 align-items-center"
    >
      <Box
        width={fullWidth ? "100%" : "80%"}
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            columnGap: "8px",
            alignItems: "center",
          }}
        > {icon}
          <Typography color={theme.primaryTextColor} fontSize={titleFontSize}>
            {title}
          </Typography>
          {isStaticData && date ? (
            <Tooltip title={`Dados de ${formatDate(date)} `}>
              <Box>
                <AccessTimeIcon
                  sx={{
                    color: "#FFFFFF",
                    width: 16,
                    marginBottom: "1px",
                  }}
                />
              </Box>
            </Tooltip>
          ) : (
            <AvailabilityIndicators
              lastUpdate={lastUpdate}
              hasDelay={hasDelay ?? false}
            />
          )}
          {hasEquipmentFilter &&
            (equipmentFilter.inversorName || equipmentFilter.ugName) && (
              <Tooltip title={GetTooltipInfoTitle()}>
                <Box display={"flex"}>
                  <InfoIcon sx={{ width: 16, height: 16 }} />
                </Box>
              </Tooltip>
            )}
          {false &&
            cardError?.Message &&
            cardError?.Message !== "nenhum erro" && (
              <Box
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  handleTostError();
                }}
              >
                <ErrorOutlineIcon
                  sx={{
                    color: "#f44336",
                    width: 16,
                    marginBottom: "1px",
                  }}
                />
              </Box>
            )}
          {dataHoraCaptura && (
            <Tooltip
              title={
                hasColetaDelay
                  ? "Última coleta feita há mais de 10 minutos"
                  : "Última Coleta"
              }
            >
              <Typography
                color={hasColetaDelay ? "#f44336" : theme.primaryTextColor}
                fontSize="14px"
              >
                {formatDataHoraCaptura(dataHoraCaptura)}
              </Typography>
            </Tooltip>
          )}
        </Box>
        {props.toggleItems && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            marginBottom={1}
          >
            <Typography sx={{ marginRight: "4px", fontSize: "12px" }}>
              {props.toggleItems?.disabledLabel}
            </Typography>
            <Switch
              size="small"
              checked={props.toggleItems.toggleValue}
              onChange={() => {
                props.toggleItems?.setToggleValue &&
                  props.toggleItems.setToggleValue(
                    !props.toggleItems.toggleValue
                  );
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
            <Typography sx={{ marginLeft: "4px", fontSize: "12px" }}>
              {props.toggleItems?.enabledLabel}
            </Typography>
          </Box>
        )}
      </Box>
      <></>
      <BasicPopover
        sx={{
          display: {
            xs: (canEditLayout && cardId) || elementRef ? "flex" : "none",
            md: showOptions ? "block" : "none",
          },
          height: "100%",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <>
          <List>
            {elementRef && (
              <>
                {!hideExportImage && (
                  <ListItem
                    onClick={htmlToImageConvert}
                    style={{ cursor: "pointer" }}
                  >
                    <FontAwesomeIcon
                      icon={faImage}
                      color={theme.primaryTextColor}
                      size="sm"
                      className="me-2"
                    />
                    <Typography>Exportar Imagem</Typography>
                  </ListItem>
                )}
                {props.colorButton && (
                  <ListItem
                    onClick={() =>
                      setOpenColorsModal && setOpenColorsModal(true)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <ColorLensIcon
                      sx={{
                        color: theme.primaryTextColor,
                        marginRight: "8px",
                        width: "19px",
                        height: "19px",
                      }}
                    />
                    <Typography>Alterar Cores</Typography>
                  </ListItem>
                )}
                {hasFilter && (
                  <ListItem
                    onClick={() =>
                      setOpenFilterModal && setOpenFilterModal(true)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <TuneIcon
                      sx={{
                        color: theme.primaryTextColor,
                        marginRight: "8px",
                        width: "19px",
                        height: "19px",
                      }}
                    />
                    <Typography>Filtros</Typography>
                  </ListItem>
                )}
              </>
            )}
            {canEditLayout && cardId && (
              <ListItem
                onClick={() => {
                  cardId && removeCard(cardId);
                }}
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon
                  icon={faTrashCan}
                  color={theme.primaryTextColor}
                  size="sm"
                  className="me-2"
                />
                <Typography>Remover Item</Typography>
              </ListItem>
            )}
          </List>
        </>
      </BasicPopover>
      <EditColorModal
        onConfirm={onConfirmColorsModal}
        options={colorsOptions ?? []}
        open={openColorsModal ?? false}
        setOpen={setOpenColorsModal ?? (() => { })}
        title={title ?? ""}
      />
      <FilterCardModal
        onConfirm={onConfirmFilterModal}
        hour={hour}
        open={openFilterModal ?? false}
        setOpen={setOpenFilterModal ?? (() => { })}
        title={title ?? ""}
        possibleDateFilters={[
          {
            label: "Live",
            value: CardFilterOptionsEnum.Live,
          },
          ...(isDisponibilidadeCard
            ? [
              {
                label: "Hora",
                value: CardFilterOptionsEnum.Hora,
              },
            ]
            : []),
          {
            label: "Dia",
            value: CardFilterOptionsEnum.Dia,
          },
          // OBS: Em desenvolvimento
          // {
          //   label: "Mes",
          //   value: CardFilterOptionsEnum.Mes,
          // },
          // {
          //   label: "Ano",
          //   value: CardFilterOptionsEnum.Ano,
          // },
        ]}
        setHour={setHour ?? (() => { })}
        setDateFilterType={setDateFilter ?? (() => { })}
        setDate={setDate ?? (() => { })}
        date={date ?? null}
        dateFilterType={dateFilter ?? null}
      />
    </Box>
  );
}

export function BasicPopover(props: {
  children: React.ReactNode;
  sx: SxProps<Theme>;
}) {
  const { children } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <Box sx={props.sx}>
      <Box style={{ cursor: "pointer" }} onClick={handleClick} className="px-2">
        <FontAwesomeIcon icon={faEllipsisVertical} size="sm" />
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {children}
      </Popover>
    </Box>
  );
}

export function sendDashboardHistoryParams(
  date: string | Date | null,
  filterType: CardFilterOptionsEnum | undefined,
  cardType: number,
  selectedUsina: UsinaByClient | undefined,
  requestParamCards: string[],
  setRequestParamCards: (requestParamCards: string[]) => void
) {
  const convertParamToData: GetRopCardParams[] = requestParamCards.map(
    (param) => JSON.parse(param)
  );
  if (filterType === CardFilterOptionsEnum.Live) {
    const removeLiveCard = convertParamToData
      .filter((card) => {
        return card.ropCardType !== cardType;
      })
      .map((card) => JSON.stringify(card));
    setRequestParamCards(removeLiveCard);
    return;
  }
  if (
    formatDate(date ?? new Date()) !== formatDate(new Date()) &&
    selectedUsina?.usinaIds.ropInputId
  ) {
    const getParams: GetRopCardParams = {
      ropCardType: cardType == CardTypesEnum.GeracaoPlanta ? 13 : cardType,
      usinaId: selectedUsina?.usinaIds.ropInputId,
      date: formatDateRequest(date ?? new Date()),
      interval:
        filterType === CardFilterOptionsEnum.Hora ? 1 : Number(filterType),
    };

    const foundCard = convertParamToData.find(
      (card) => card.ropCardType === getParams.ropCardType
    );

    if (foundCard) {
      const updatedRequestParamCards = requestParamCards.filter((param) => {
        const parsedParam: GetRopCardParams = JSON.parse(param);
        return parsedParam.ropCardType !== foundCard.ropCardType;
      });

      setRequestParamCards([
        ...updatedRequestParamCards,
        JSON.stringify(getParams),
      ]);
    } else {
      setRequestParamCards([...requestParamCards, JSON.stringify(getParams)]);
    }
  }
}
